export const DocumentType = Object.freeze({
    DNI: 1,
    CARNET_EXTRANJERIA: 2,
    RUC: 3,
    PASAPORTE: 4,
    PARTIDA_NACIMIENTO: 5,
    OTRO: 6,
});
